import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { Button } from '@salesforce/design-system-react';
import { ExclusionRow } from '../';
import './ExclusionRulesEditor.scss';

class ExclusionRulesEditor extends Component {
  //TODO: implement typeahead?
  rows() {
    const rules = this.props.exclusionRules || {};

    return Object.values(rules).map((rule, index) => {
      return (
        <ExclusionRow
          ruleNumber={index + 1}
          id={`rule${index}`}
          key={`rule${index}`}
          {...rule}
          actions={this.props.actions}
          assetAttributes={this.props.assetAttributes}
          consumerAttributes={this.props.profileAttributes}
          onDeleteRule={() => this.props.onDeleteRule(index)}
          onRuleChange={update => this.props.onRuleChange(index, update)}
        />
      );
    });
  }

  render() {
    const { formatMessage } = this.props.intl;
    const addRule = formatMessage({
      id: 'components.ecs.rules.selection.addRule'
    });
    return (
      <div className="select-again-editor">
        <div className="exclusion-rule-rows">{this.rows()}</div>
        <Button
          className="exclusion-add-rule-button"
          label={addRule}
          disabled={this.props.canAddRule}
          iconCategory="utility"
          iconName="add"
          iconPosition="left"
          onClick={this.props.onAddRule}
        />
      </div>
    );
  }
}

ExclusionRulesEditor.propTypes = {
  actions: PropTypes.object.isRequired,
  assetAttributes: PropTypes.array,
  profileAttributes: PropTypes.array,
  exclusionRules: PropTypes.array,
  loadedExclusionRules: PropTypes.array,
  canAddRule: PropTypes.bool.isRequired,
  onAddRule: PropTypes.func.isRequired,
  onDeleteRule: PropTypes.func.isRequired,
  onRuleChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(ExclusionRulesEditor);
